import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main.topic');
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';
import { BenchmarkDetail } from '../benchmark-catalog';
import { AWESOME_LLM_APP_SECTIONS, AwesomeLlmAppEntry, AwesomeLlmAppSection } from '../awesome-llm-apps-catalog';
import {
    extractSemanticGraphFileText,
    HWP_PDF_CONVERSION_MESSAGE,
    isHwpDocumentFile,
    SEMANTIC_GRAPH_ACCEPTED_FILE_TYPES,
    SemanticGraphModel,
} from '../semantic-graph';

type TopicEntry = AwesomeLlmAppEntry;
type TopicPage = AwesomeLlmAppSection;

interface BenchmarkGroup {
    id: string;
    title: string;
    items: BenchmarkDetail[];
}

interface TopicSubtopic {
    id: string;
    title: string;
    category: string;
    summary: string;
    href: string;
    sourceHref: string;
    itemsCount: number;
    groups: BenchmarkGroup[];
}

interface RankedEntry {
    entry: TopicEntry;
    score: number;
    relevance: number;
    matchedTerms: string[];
}

interface GraphNode extends TopicEntry {
    left: string;
    top: string;
    score: number;
}

const TOPIC_SUBTOPICS: Record<string, TopicSubtopic[]> = {};

const TOPICS: TopicPage[] = AWESOME_LLM_APP_SECTIONS;

@Component({
    selector: 'wiz-page-main-topic',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main.topic/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100vh;
  color: #172033;
  background: #f6f7f9;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
  box-sizing: border-box;
}

.access-shell {
  width: 100%;
  min-width: 0;
  min-height: 100vh;
  background: #f6f7f9;
  box-sizing: border-box;
}

.access-shell * {
  box-sizing: border-box;
}

.access-header {
  border-bottom: 1px solid #cfd6df;
  background: #ffffff;
}

.access-header__inner,
.access-command__inner,
.wiki-board__inner {
  width: min(1360px, 100% - 48px);
  margin: 0 auto;
}

.access-header__inner {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.access-brand {
  display: flex;
  align-items: center;
  width: 158px;
  min-width: 140px;
  color: #111827;
  text-decoration: none;
}

.access-brand__text {
  color: inherit;
  font-size: 19px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
}

.access-header__action {
  appearance: none;
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1d4f91;
  border-radius: 6px;
  padding: 0 14px;
  color: #ffffff;
  background: #1d4f91;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.35;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.access-header__action:hover,
.access-header__action:focus-visible {
  background: #163f75;
  outline: none;
}

.access-command {
  border-bottom: 1px solid #cfd6df;
  background: #ffffff;
}

.skill-research {
  border-bottom: 1px solid #cfd6df;
  background: #f0f7f5;
}

.skill-research--caveman {
  background: #eef4ff;
}

.skill-research--caveman .skill-card {
  border-color: #c7d7f1;
}

.skill-research--caveman .access-kicker,
.skill-research--caveman .skill-card__label {
  color: #1d4f91;
}

.skill-research--caveman .skill-sources a {
  border-color: #a9bfe5;
  color: #1d4f91;
}

.skill-research--caveman .skill-sources a:hover,
.skill-research--caveman .skill-sources a:focus-visible {
  color: #ffffff;
  background: #1d4f91;
}

.skill-research__inner {
  width: min(1360px, 100% - 48px);
  margin: 0 auto;
  padding: 28px 0 30px;
}

.skill-research__head {
  max-width: 860px;
}

.skill-research__head h2 {
  margin: 0;
  color: #101828;
  font-size: 26px;
  line-height: 1.28;
  font-weight: 900;
  letter-spacing: 0;
}

.skill-research__head p:last-child {
  margin: 10px 0 0;
  color: #475467;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 700;
}

.skill-research__grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.skill-card {
  min-width: 0;
  border: 1px solid #c5d7d2;
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
}

.skill-card__label {
  color: #006a67;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 900;
}

.skill-card h3,
.skill-compare__column h3 {
  margin: 6px 0 0;
  color: #101828;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 900;
  letter-spacing: 0;
}

.skill-card p {
  margin: 8px 0 0;
  color: #586474;
  font-size: 13px;
  line-height: 1.65;
  font-weight: 650;
}

.skill-compare {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #c5d7d2;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.skill-compare__column {
  min-width: 0;
  padding: 16px;
}

.skill-compare__column + .skill-compare__column {
  border-left: 1px solid #c5d7d2;
}

.skill-compare__column.is-strong {
  background: #fbfffe;
}

.skill-compare__column ul {
  margin: 10px 0 0;
  padding-left: 18px;
  color: #586474;
  font-size: 13px;
  line-height: 1.7;
  font-weight: 650;
}

.skill-sources {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.skill-sources a {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #99beb7;
  border-radius: 6px;
  padding: 0 10px;
  color: #006a67;
  background: #ffffff;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
}

.skill-sources a:hover,
.skill-sources a:focus-visible {
  color: #ffffff;
  background: #006a67;
  outline: none;
}

.wiki-board {
  transition: opacity 180ms ease, transform 180ms ease;
}

.access-shell.is-route-changing .wiki-board {
  opacity: 0;
  transform: translateY(8px);
}

.access-command__inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(420px, 500px);
  gap: 32px;
  min-height: clamp(430px, 100vh - 198px, 620px);
  padding: 44px 0 48px;
  align-items: center;
}

.search-console {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search-console__heading {
  max-width: 760px;
}

.access-kicker {
  margin: 0 0 8px;
  color: #006a67;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
}

.search-console h1 {
  margin: 0;
  color: #101828;
  font-size: 34px;
  line-height: 1.22;
  font-weight: 900;
  letter-spacing: 0;
}

.search-console__heading p:last-child {
  margin: 10px 0 0;
  color: #586474;
  font-size: 15px;
  line-height: 1.65;
  font-weight: 650;
}

.wiki-search {
  width: min(780px, 100%);
  margin-top: 20px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 96px;
  border: 1px solid #98a2b3;
  border-radius: 6px;
  background: #ffffff;
  overflow: hidden;
}

.wiki-search input {
  min-width: 0;
  height: 50px;
  border: 0;
  padding: 0 16px;
  color: #172033;
  background: transparent;
  font: inherit;
  font-size: 15px;
  font-weight: 650;
  outline: none;
}

.wiki-search input::placeholder {
  color: #7a8493;
}

.wiki-search button {
  height: 50px;
  border: 0;
  border-left: 1px solid #98a2b3;
  color: #ffffff;
  background: #1d4f91;
  font: inherit;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
}

.wiki-search button:hover,
.wiki-search button:focus-visible {
  background: #163f75;
  outline: none;
}

.command-actions {
  width: min(780px, 100%);
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.command-action {
  appearance: none;
  min-width: 0;
  min-height: 62px;
  border: 1px solid #cfd6df;
  border-radius: 8px;
  padding: 11px 13px;
  display: grid;
  align-content: center;
  gap: 4px;
  color: #172033;
  background: #ffffff;
  font: inherit;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.command-action:hover,
.command-action:focus-visible {
  border-color: #1d4f91;
  outline: none;
}

.command-action--primary {
  border-color: #1d4f91;
  color: #ffffff;
  background: #1d4f91;
}

.command-action--primary:hover,
.command-action--primary:focus-visible {
  background: #163f75;
}

.command-action strong,
.command-action span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.command-action strong {
  font-size: 14px;
  font-weight: 900;
  line-height: 1.35;
}

.command-action span {
  color: #667085;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.45;
}

.command-action--primary span {
  color: #dbeafe;
}

.created-doc-link {
  width: min(780px, 100%);
  margin-top: 12px;
  display: grid;
  gap: 8px;
  border: 1px solid #bad2f2;
  border-radius: 8px;
  padding: 14px;
  background: #f5f9ff;
}

.created-doc-link__head {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.created-doc-link__head span {
  color: #1d4f91;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 900;
}

.created-doc-link__head strong {
  min-width: 0;
  color: #101828;
  font-size: 15px;
  line-height: 1.4;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.created-doc-link__url {
  min-width: 0;
  color: #1d4f91;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 850;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.created-doc-link__url:hover,
.created-doc-link__url:focus-visible {
  text-decoration: underline;
  outline: none;
}

.created-doc-link small {
  min-width: 0;
  color: #586474;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.search-window {
  width: min(780px, 100%);
  margin-top: 16px;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  padding: 16px 18px 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.08);
}

.search-window__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.search-window__eyebrow {
  margin: 0 0 4px;
  color: #008c72;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 900;
}

.search-window h2 {
  min-width: 0;
  margin: 0;
  color: #101828;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.search-window__badge {
  flex: 0 0 auto;
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #cfd6df;
  border-radius: 999px;
  padding: 0 10px;
  color: #475467;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 900;
}

.search-window__list {
  margin-top: 12px;
  display: grid;
  border-bottom: 1px solid #e4e7ec;
}

.search-result {
  min-width: 0;
  display: grid;
  gap: 5px;
  padding: 14px 0;
  border-top: 1px solid #e4e7ec;
  color: inherit;
  text-decoration: none;
}

.search-result:hover strong,
.search-result:focus-visible strong {
  color: #1d4f91;
}

.search-result:focus-visible {
  outline: 2px solid #1d4f91;
  outline-offset: 2px;
}

.search-result__path {
  min-width: 0;
  color: #008c72;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 850;
  overflow-wrap: anywhere;
}

.search-result__meta {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  color: #667085;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 800;
}

.search-result__meta b,
.search-result__meta em,
.search-result__meta span {
  font: inherit;
}

.search-result__meta em {
  color: #1d4f91;
}

.recent-list span {
  color: #b54708;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 900;
}

.search-result strong,
.wiki-entry strong,
.recent-list strong {
  min-width: 0;
  color: #101828;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.search-result small,
.wiki-entry small {
  min-width: 0;
  color: #586474;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.search-window__empty {
  margin-top: 12px;
  border-top: 1px solid #e4e7ec;
  padding-top: 14px;
}

.search-window__empty strong {
  display: block;
  color: #101828;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 900;
}

.search-window__empty p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 700;
}

.graph-panel {
  min-width: 0;
  align-self: center;
  border: 1px solid #cfd6df;
  border-radius: 8px;
  padding: 18px;
  background: #fbfcfe;
}

.graph-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.graph-panel__head h2 {
  margin: 0;
  color: #101828;
  font-size: 21px;
  line-height: 1.3;
  font-weight: 900;
  letter-spacing: 0;
}

.graph-panel__meta {
  flex: 0 0 auto;
  color: #475467;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 850;
}

.graph-controls {
  margin-top: 14px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 150px;
  gap: 8px;
}

.graph-query {
  min-width: 0;
  min-height: 18px;
  margin: 10px 0 0;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 750;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-upload {
  position: relative;
  min-width: 0;
  min-height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #98a2b3;
  border-radius: 6px;
  padding: 0 12px;
  color: #172033;
  background: #ffffff;
  font-size: 13px;
  font-weight: 850;
  cursor: pointer;
}

.graph-upload input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.graph-upload span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.graph-keyword {
  min-width: 0;
  height: 40px;
  border: 1px solid #98a2b3;
  border-radius: 6px;
  padding: 0 10px;
  color: #172033;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  outline: none;
}

.graph-upload:hover,
.graph-upload:focus-within,
.graph-keyword:focus {
  border-color: #1d4f91;
}

.graph-canvas {
  position: relative;
  min-height: 316px;
  margin-top: 16px;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  background: linear-gradient(#eef2f7 1px, transparent 1px), linear-gradient(90deg, #eef2f7 1px, transparent 1px), #ffffff;
  background-size: 34px 34px;
  overflow: hidden;
}

.graph-line {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 150px;
  height: 1px;
  background: #8aa4c8;
  transform-origin: left center;
  opacity: 0.8;
}

.graph-line--one {
  transform: rotate(-34deg);
}

.graph-line--two {
  transform: rotate(30deg);
}

.graph-line--three {
  width: 135px;
  transform: rotate(146deg);
}

.graph-line--four {
  width: 130px;
  transform: rotate(210deg);
}

.graph-node {
  position: absolute;
  z-index: 2;
  width: 145px;
  min-height: 74px;
  display: grid;
  gap: 4px;
  align-content: center;
  border: 1px solid #b8c4d4;
  border-radius: 8px;
  padding: 10px;
  color: inherit;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.08);
  text-decoration: none;
  transform: translate(-50%, -50%);
}

.graph-node:hover,
.graph-node:focus-visible {
  border-color: #1d4f91;
  outline: none;
}

.graph-node--source {
  left: 50%;
  top: 50%;
  width: 132px;
  min-height: 86px;
  border-color: #006a67;
  background: #f0fbfa;
  box-shadow: 0 10px 26px rgba(0, 106, 103, 0.16);
}

.graph-node span {
  color: #006a67;
  font-size: 11px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.graph-node strong {
  min-width: 0;
  color: #101828;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.graph-node small {
  color: #667085;
  font-size: 11px;
  line-height: 1.4;
  font-weight: 750;
}

.wiki-board__inner {
  display: grid;
  grid-template-columns: minmax(210px, 240px) minmax(0, 1fr);
  gap: 30px;
  padding: 30px 0 72px;
  align-items: start;
}

.wiki-directory {
  position: sticky;
  top: 24px;
  min-width: 0;
}

.wiki-directory h2,
.side-section h2 {
  margin: 0 0 12px;
  color: #101828;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 900;
  letter-spacing: 0;
}

.directory-list {
  display: grid;
  border-top: 1px solid #cfd6df;
}

.directory-list a {
  min-width: 0;
  min-height: 48px;
  display: grid;
  align-content: center;
  gap: 4px;
  border-bottom: 1px solid #cfd6df;
  border-left: 3px solid transparent;
  padding: 10px 8px 10px 12px;
  color: #344054;
  background: transparent;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.directory-list a:hover,
.directory-list a:focus-visible,
.directory-list a.is-active {
  border-left-color: #1d4f91;
  background: #eaf1fb;
  outline: none;
}

.directory-list strong {
  min-width: 0;
  color: #172033;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.directory-list span {
  color: #667085;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 750;
}

.wiki-content {
  min-width: 0;
}

.wiki-section {
  min-width: 0;
  margin-bottom: 30px;
  border-top: 2px solid #172033;
  transition: background 160ms ease, border-color 160ms ease;
}

.wiki-section:last-child {
  margin-bottom: 0;
}

.wiki-section.is-selected {
  border-top-color: #172033;
  border-bottom: 2px solid #172033;
  padding-left: 0;
  background: transparent;
}

.wiki-section__head {
  display: grid;
  grid-template-columns: minmax(180px, 240px) minmax(0, 1fr);
  gap: 24px;
  padding: 14px 0;
  border-bottom: 1px solid #cfd6df;
}

.wiki-section__title {
  min-width: 0;
  display: grid;
  gap: 5px;
  align-content: start;
}

.wiki-section__head h2 {
  margin: 0;
  color: #101828;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 900;
  letter-spacing: 0;
}

.wiki-section__title small {
  color: #667085;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 850;
}

.wiki-section__copy {
  min-width: 0;
  display: grid;
  gap: 7px;
  align-content: start;
}

.wiki-section__copy strong {
  min-width: 0;
  color: #172033;
  font-size: 15px;
  line-height: 1.55;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.wiki-section__head p,
.wiki-section__copy p {
  margin: 0;
  color: #586474;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.wiki-entry__category {
  color: #006a67;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.wiki-entry-list {
  display: grid;
}

.wiki-entry {
  min-width: 0;
  display: grid;
  grid-template-columns: 58px minmax(110px, 170px) minmax(150px, 280px) minmax(220px, 1fr);
  gap: 16px;
  align-items: baseline;
  padding: 12px 0;
  border-bottom: 1px solid #e4e7ec;
  color: inherit;
  text-decoration: none;
}

.wiki-entry:hover strong,
.wiki-entry:focus-visible strong,
.recent-list a:hover strong,
.recent-list a:focus-visible strong {
  color: #1d4f91;
}

.wiki-entry:focus-visible,
.recent-list a:focus-visible {
  outline: 2px solid #1d4f91;
  outline-offset: 2px;
}

.wiki-entry__number {
  min-width: 0;
  display: block;
  color: #667085;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
}

.wiki-entry small {
  text-align: right;
}

.second-filter-panel {
  display: grid;
  grid-template-columns: minmax(180px, 240px) minmax(0, 1fr);
  gap: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #cfd6df;
}

.second-filter-panel__head {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 5px;
}

.second-filter-panel__head span,
.second-filter-card span {
  color: #006a67;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 900;
}

.second-filter-panel__head strong {
  color: #101828;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 900;
}

.second-filter-panel__head small {
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
  font-weight: 750;
}

.second-filter-list {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.second-filter-card {
  min-width: 0;
  min-height: 112px;
  display: grid;
  gap: 6px;
  align-content: start;
  border: 1px solid #cfd6df;
  border-radius: 8px;
  padding: 14px;
  color: inherit;
  background: #ffffff;
  text-decoration: none;
}

.second-filter-card:hover,
.second-filter-card:focus-visible {
  border-color: #1d4f91;
  background: #f4f8ff;
  outline: none;
}

.second-filter-card strong {
  color: #101828;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 900;
}

.second-filter-card small {
  color: #586474;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 650;
}

.second-filter-card em {
  color: #1d4f91;
  font-size: 12px;
  line-height: 1.4;
  font-style: normal;
  font-weight: 900;
}

.wiki-subtopic {
  min-width: 0;
  border-top: 2px solid #172033;
}

.subtopic-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 0;
  border-bottom: 1px solid #cfd6df;
}

.subtopic-toolbar a {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #98a2b3;
  border-radius: 6px;
  padding: 0 10px;
  color: #344054;
  background: #ffffff;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 850;
  text-decoration: none;
}

.subtopic-toolbar a:hover,
.subtopic-toolbar a:focus-visible {
  border-color: #1d4f91;
  color: #ffffff;
  background: #1d4f91;
  outline: none;
}

.subcategory-index {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1px solid #cfd6df;
}

.subcategory-index a {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  padding: 10px 12px;
  color: inherit;
  background: #ffffff;
  text-decoration: none;
}

.subcategory-index a:hover,
.subcategory-index a:focus-visible {
  border-color: #1d4f91;
  background: #f4f8ff;
  outline: none;
}

.subcategory-index strong {
  min-width: 0;
  color: #101828;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.subcategory-index span {
  color: #667085;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 850;
}

.benchmark-directory {
  display: grid;
  gap: 22px;
  padding-top: 20px;
}

.benchmark-family {
  min-width: 0;
  border-top: 1px solid #172033;
}

.benchmark-family__head {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #cfd6df;
}

.benchmark-family__head h3 {
  margin: 0;
  color: #101828;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 900;
}

.benchmark-family__head span {
  color: #475467;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 900;
}

.benchmark-row-list {
  display: grid;
}

.benchmark-row {
  min-width: 0;
  display: grid;
  grid-template-columns: 44px minmax(120px, 180px) minmax(220px, 1fr) minmax(88px, 150px);
  gap: 14px;
  align-items: baseline;
  padding: 12px 0;
  border-bottom: 1px solid #e4e7ec;
  color: inherit;
  text-decoration: none;
}

.benchmark-row:hover strong,
.benchmark-row:focus-visible strong {
  color: #1d4f91;
}

.benchmark-row:focus-visible {
  outline: 2px solid #1d4f91;
  outline-offset: 2px;
}

.benchmark-row__number {
  color: #667085;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
}

.benchmark-row strong {
  min-width: 0;
  color: #101828;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.benchmark-row small {
  min-width: 0;
  color: #586474;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.benchmark-row em {
  min-width: 0;
  justify-self: end;
  color: #1d4f91;
  font-size: 12px;
  line-height: 1.45;
  font-style: normal;
  font-weight: 850;
  overflow-wrap: anywhere;
  text-align: right;
}

.side-section {
  min-width: 0;
  margin-bottom: 24px;
  border-top: 2px solid #172033;
  padding-top: 12px;
}

.recent-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid #cfd6df;
}

.recent-list li {
  border-bottom: 1px solid #e4e7ec;
}

.recent-list a {
  min-width: 0;
  display: grid;
  gap: 4px;
  padding: 10px 0;
  color: inherit;
  text-decoration: none;
}

.index-stats {
  margin: 0;
  display: grid;
  border-top: 1px solid #cfd6df;
}

.index-stats div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #e4e7ec;
}

.index-stats dt,
.index-stats dd {
  margin: 0;
  color: #475467;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 800;
}

.index-stats dd {
  color: #101828;
  font-weight: 900;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1180px) {
  .access-command__inner {
    grid-template-columns: minmax(0, 1fr) 390px;
    gap: 24px;
  }
  .wiki-board__inner {
    grid-template-columns: 200px minmax(0, 1fr);
  }
}
@media (max-width: 900px) {
  .access-command__inner,
  .wiki-board__inner {
    grid-template-columns: 1fr;
  }
  .access-command__inner {
    min-height: auto;
    padding: 34px 0 38px;
    align-items: stretch;
  }
  .wiki-directory {
    position: static;
  }
  .directory-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-left: 1px solid #cfd6df;
  }
  .directory-list a {
    border-right: 1px solid #cfd6df;
  }
  .subcategory-index {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .benchmark-row {
    grid-template-columns: 44px minmax(120px, 180px) minmax(0, 1fr);
  }
  .benchmark-row em {
    grid-column: 3;
    justify-self: start;
    text-align: left;
  }
}
@media (max-width: 640px) {
  .access-header__inner,
  .access-command__inner,
  .skill-research__inner,
  .wiki-board__inner {
    width: min(100% - 28px, 1360px);
  }
  .access-header__inner {
    min-height: 64px;
  }
  .access-brand {
    width: 146px;
  }
  .access-header__action {
    min-height: 36px;
    padding: 0 11px;
    white-space: normal;
  }
  .access-command__inner {
    padding: 26px 0 30px;
  }
  .search-console h1 {
    font-size: 29px;
  }
  .search-window {
    padding: 14px;
  }
  .search-window__top {
    display: grid;
    gap: 10px;
  }
  .search-window__badge {
    justify-self: start;
  }
  .wiki-search,
  .command-actions,
  .graph-controls,
  .search-result,
  .wiki-section__head,
  .second-filter-panel,
  .second-filter-list,
  .subcategory-index,
  .skill-research__grid,
  .skill-compare {
    grid-template-columns: 1fr;
  }
  .skill-compare__column + .skill-compare__column {
    border-top: 1px solid #c5d7d2;
    border-left: 0;
  }
  .wiki-entry {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 6px 10px;
    align-items: start;
  }
  .wiki-entry small {
    grid-column: 2;
    text-align: left;
  }
  .wiki-entry__category,
  .wiki-entry strong {
    grid-column: 2;
  }
  .benchmark-family__head,
  .benchmark-row {
    grid-template-columns: 1fr;
  }
  .benchmark-row {
    gap: 5px;
    align-items: start;
  }
  .benchmark-row em {
    grid-column: auto;
  }
  .wiki-search button {
    border-left: 0;
    border-top: 1px solid #98a2b3;
  }
  .graph-canvas {
    min-height: 0;
    display: grid;
    gap: 10px;
    padding: 12px;
    background: #ffffff;
  }
  .graph-line {
    display: none;
  }
  .graph-node,
  .graph-node--source {
    position: static;
    width: auto;
    min-height: 0;
    transform: none;
    box-shadow: none;
  }
  .directory-list {
    grid-template-columns: 1fr;
  }
  .directory-list a {
    border-right: 0;
  }
}
.directory-list a {
  align-content: center;
}

.wiki-section__head {
  align-items: center;
}

.wiki-section__title,
.wiki-section__copy {
  align-content: center;
}`],
})
export class PageMainTopicComponent implements AfterViewInit, OnInit, OnDestroy {
    public readonly topics = TOPICS;
    public readonly graphAcceptedFileTypes = SEMANTIC_GRAPH_ACCEPTED_FILE_TYPES;
    public topic = TOPICS[0];
    public subtopic: TopicSubtopic | undefined;
    public isTransitioning = false;
    public searchQuery = '';
    public hasSearched = false;
    public graphSeed = '';
    public selectedFileName = '';
    public graphSourceSummary = '';
    public graphNodes: GraphNode[] = [];
    public graphModelLabel = 'AI 모델 준비';

    private uploadedText = '';
    private hasResolvedTopic = false;
    private routeSubscription?: Subscription;
    private transitionTimer?: number;
    private graphRefreshTimer?: number;
    private graphRefreshToken = 0;
    private readonly graphModel = new SemanticGraphModel<TopicEntry>();
    private readonly graphSlots = [
        { left: '72%', top: '16%' },
        { left: '78%', top: '66%' },
        { left: '24%', top: '70%' },
        { left: '20%', top: '22%' },
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,    ) { }

    public get currentSubtopics(): TopicSubtopic[] {
        return TOPIC_SUBTOPICS[this.topic.id] || [];
    }

    public get topicChapterNumber(): number {
        return Number(this.topic.order);
    }

    public get allEntries(): TopicEntry[] {
        return this.topics.reduce((entries, topic) => entries.concat(topic.entries), [] as TopicEntry[]);
    }

    public get searchableEntries(): TopicEntry[] {
        return this.allEntries;
    }

    public get filteredEntries(): TopicEntry[] {
        return this.searchResults.map((item) => item.entry);
    }

    public get searchResults(): RankedEntry[] {
        const query = this.normalize(this.searchQuery);

        if (!query) {
            return [];
        }

        return this.rankEntries(query)
            .filter((item) => item.score > 0)
            .slice(0, 12);
    }

    public get searchQueryLabel(): string {
        return this.compactQuery(this.searchQuery);
    }

    public get graphSourceLabel(): string {
        if (this.uploadedText && this.graphSourceSummary) {
            return this.graphSourceSummary;
        }

        return this.selectedFileName || this.graphSeed || this.searchQuery || this.topic.title;
    }

    public get graphQueryLabel(): string {
        if (this.graphSourceSummary === HWP_PDF_CONVERSION_MESSAGE) {
            return this.graphSourceSummary;
        }

        if (this.uploadedText) {
            return `AI 추천 입력: ${this.compactQuery(this.graphSourceSummary || this.uploadedText)}`;
        }

        if (this.selectedFileName && this.graphSourceSummary) {
            return `AI 추천 입력: ${this.compactQuery(this.graphSourceSummary)}`;
        }

        if (this.graphSeed) {
            return `AI 추천 입력: ${this.compactQuery(this.graphSeed)}`;
        }

        if (this.selectedFileName) {
            return `AI 추천 입력: ${this.compactQuery(this.selectedFileName)}`;
        }

        if (this.searchQuery) {
            return `AI 추천 입력: ${this.compactQuery(this.searchQuery)}`;
        }

        return `AI 현재 분류 입력: ${this.compactQuery(this.defaultGraphSeed)}`;
    }

    public async ngOnInit() {
        await this.service.init();
        this.hydrateSharedState();

        this.routeSubscription = new Subscription();
        this.routeSubscription.add(this.route.paramMap.subscribe((params) => {
            this.syncTopic(params.get('section'), params.get('subsection'));
        }));
        this.routeSubscription.add(this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.syncTopic();
            }
        }));
    }

    public ngAfterViewInit() {
        this.restoreDirectoryScroll();
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();

        if (this.transitionTimer) {
            window.clearTimeout(this.transitionTimer);
        }

        if (this.graphRefreshTimer) {
            window.clearTimeout(this.graphRefreshTimer);
        }
    }

    public topicUrl(topic: TopicPage) {
        return `/main/${topic.id}`;
    }

    public subtopicUrl(topic: TopicPage, subtopic: TopicSubtopic) {
        return `/main/${topic.id}/${subtopic.id}`;
    }

    public preserveDirectoryScroll(event?: MouseEvent) {
        if (event && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
            return;
        }

        const board = document.querySelector('.wiki-board') as HTMLElement | null;
        const boardTop = board ? Math.max(0, Math.round(window.scrollY + board.getBoundingClientRect().top - 24)) : window.scrollY;
        const state = this.getSharedState();
        state.pendingDirectoryScrollTop = Math.max(window.scrollY, boardTop);
    }

    public submitSearch(event: Event) {
        event.preventDefault();

        const query = this.searchQuery.trim();
        this.hasSearched = false;
        this.persistSharedState();

        if (!query) {
            return;
        }

        this.router.navigateByUrl(`/search?q=${encodeURIComponent(query)}`);
    }

    public onSearchInput(event: Event) {
        this.searchQuery = this.getInputValue(event);

        if (!this.searchQuery.trim()) {
            this.hasSearched = false;
        }

        this.persistSharedState();
        this.scheduleGraphRefresh();
    }

    public onGraphSeedInput(event: Event) {
        this.graphSeed = this.getInputValue(event);
        this.uploadedText = '';
        this.graphSourceSummary = '';
        this.persistSharedState();
        this.scheduleGraphRefresh();
    }

    public async onGraphFileChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files && input.files[0];

        if (!file) {
            return;
        }

        this.selectedFileName = file.name;
        this.graphSeed = '';
        this.uploadedText = '';

        if (isHwpDocumentFile(file)) {
            this.graphSourceSummary = HWP_PDF_CONVERSION_MESSAGE;
            this.graphModelLabel = 'PDF 변환 필요';
            this.graphNodes = [];
            this.persistSharedState();
            await this.service.render();
            return;
        }

        this.graphSourceSummary = '파일 분석 중';
        this.graphModelLabel = '파일 분석 중';
        this.persistSharedState();
        await this.service.render();

        try {
            const parsed = await extractSemanticGraphFileText(file);
            this.uploadedText = parsed.text;
            this.graphSourceSummary = parsed.summary;
            this.graphSeed = parsed.usedFallback ? parsed.text : '';
        } catch (_) {
            this.graphSeed = file.name.replace(/\.[^.]+$/, '').replace(/[_-]+/g, ' ');
            this.graphSourceSummary = '파일 텍스트 추출 실패';
        }

        this.persistSharedState();
        this.refreshGraphNodes();
    }

    public trackByTopic(_: number, topic: TopicPage) {
        return topic.id;
    }

    public trackByEntry(_: number, entry: TopicEntry) {
        return entry.id;
    }

    public trackByGraphNode(_: number, node: GraphNode) {
        return node.id;
    }

    public trackBySearchResult(_: number, result: RankedEntry) {
        return result.entry.id;
    }

    public trackBySubtopic(_: number, subtopic: TopicSubtopic) {
        return subtopic.id;
    }

    public trackByBenchmarkGroup(_: number, group: BenchmarkGroup) {
        return group.id;
    }

    public trackByBenchmark(_: number, benchmark: BenchmarkDetail) {
        return benchmark.slug;
    }

    public trackByText(_: number, item: string) {
        return item;
    }

    private setTopic(sectionId: string, subtopicId = '') {
        const nextTopic = this.topics.find((item) => item.id === sectionId) || TOPICS[0];
        const legacyDraftId = this.resolveLegacyDraftId(nextTopic.id, subtopicId);

        if (legacyDraftId) {
            this.router.navigateByUrl(`/docs/draft/${legacyDraftId}`);
            return;
        }

        const nextSubtopic = this.resolveSubtopic(nextTopic.id, subtopicId);

        if (!this.hasResolvedTopic) {
            this.topic = nextTopic;
            this.subtopic = nextSubtopic;
            this.hasResolvedTopic = true;
            this.refreshGraphNodes();
            return;
        }

        if (nextTopic.id === this.topic.id && nextSubtopic?.id === this.subtopic?.id) {
            return;
        }

        this.isTransitioning = true;

        if (this.transitionTimer) {
            window.clearTimeout(this.transitionTimer);
        }

        this.transitionTimer = window.setTimeout(() => {
            this.topic = nextTopic;
            this.subtopic = nextSubtopic;
            this.isTransitioning = false;
            this.refreshGraphNodes();
        }, 120);
    }

    private syncTopic(sectionId?: string | null, subtopicId?: string | null) {
        const routeInfo = (window as any).WizRoute;
        const urlMatch = this.router.url.match(/^\/main\/([^?#/]+)(?:\/([^?#/]+))?/);
        const urlSection = urlMatch?.[1] || '';
        const urlSubtopic = urlMatch?.[2] || '';
        this.setTopic(
            sectionId || routeInfo?.segment?.section || decodeURIComponent(urlSection),
            subtopicId || routeInfo?.segment?.subsection || decodeURIComponent(urlSubtopic),
        );
    }

    private get graphSeedText(): string {
        if (this.uploadedText) {
            return `${this.graphSourceSummary} ${this.uploadedText}`.trim();
        }

        return this.graphSeed || this.selectedFileName || this.searchQuery || this.defaultGraphSeed;
    }

    private get defaultGraphSeed(): string {
        if (this.subtopic) {
            return [
                this.topic.title,
                this.subtopic.title,
                this.subtopic.groups.map((group) => `${group.title} ${group.items.map((item) => item.name).join(' ')}`).join(' '),
            ].join(' ');
        }

        return [
            this.topic.title,
            this.topic.related.join(' '),
            this.topic.entries.map((entry) => `${entry.title} ${entry.category}`).join(' '),
        ].join(' ');
    }

    private rankEntries(seed: string): RankedEntry[] {
        const normalizedSeed = this.normalize(seed);
        const tokens = this.tokenize(normalizedSeed);

        const ranked = this.searchableEntries
            .map((entry) => {
                const id = this.normalize(entry.id);
                const title = this.normalize(entry.title);
                const category = this.normalize(entry.category);
                const summary = this.normalize(entry.summary);
                const matchedTerms = new Set<string>();
                let score = 0;

                if (normalizedSeed) {
                    if (title === normalizedSeed) {
                        score += 42;
                        matchedTerms.add(normalizedSeed);
                    } else if (title.includes(normalizedSeed)) {
                        score += 26;
                        matchedTerms.add(normalizedSeed);
                    }

                    if (id.includes(normalizedSeed)) {
                        score += 18;
                        matchedTerms.add(normalizedSeed);
                    }

                    if (summary.includes(normalizedSeed)) {
                        score += 12;
                        matchedTerms.add(normalizedSeed);
                    }
                }

                tokens.forEach((token) => {
                    if (title.includes(token)) {
                        score += 12;
                        matchedTerms.add(token);
                    }

                    if (id.includes(token)) {
                        score += 9;
                        matchedTerms.add(token);
                    }

                    if (category.includes(token)) {
                        score += 7;
                        matchedTerms.add(token);
                    }

                    if (summary.includes(token)) {
                        score += 4;
                        matchedTerms.add(token);
                    }
                });

                return {
                    entry,
                    score,
                    relevance: 0,
                    matchedTerms: Array.from(matchedTerms).slice(0, 5),
                };
            })
            .sort((left, right) => {
                if (right.score !== left.score) {
                    return right.score - left.score;
                }

                return left.entry.title.localeCompare(right.entry.title);
            });

        const topScore = ranked.find((item) => item.score > 0)?.score || 1;

        return ranked.map((item) => ({
            ...item,
            relevance: item.score > 0 ? Math.max(1, Math.round((item.score / topScore) * 100)) : 0,
        }));
    }

    private scheduleGraphRefresh(delay = 260) {
        if (this.graphRefreshTimer) {
            window.clearTimeout(this.graphRefreshTimer);
        }

        this.graphRefreshTimer = window.setTimeout(() => this.refreshGraphNodes(), delay);
    }

    private async refreshGraphNodes() {
        const token = ++this.graphRefreshToken;
        const seed = this.graphSeedText;
        this.graphModelLabel = 'AI 모델 로딩';
        this.graphNodes = this.toGraphNodes(this.rankEntries(seed));
        await this.service.render();

        try {
            const ranked = await this.graphModel.rank(seed, this.searchableEntries);

            if (token !== this.graphRefreshToken) {
                return;
            }

            this.graphNodes = this.toGraphNodes(ranked);
            this.graphModelLabel = 'AI 모델';
        } catch (_) {
            if (token !== this.graphRefreshToken) {
                return;
            }

            this.graphNodes = this.toGraphNodes(this.rankEntries(seed));
            this.graphModelLabel = 'AI 대체 모드';
        }

        await this.service.render();
    }

    private toGraphNodes(items: RankedEntry[]): GraphNode[] {
        return items
            .slice(0, this.graphSlots.length)
            .map((item, index) => {
                const slot = this.graphSlots[index];
                const fallbackScore = item.score > 0 ? Math.min(97, 64 + item.score * 5) : 58 - index * 3;
                const score = item.relevance > 0 ? item.relevance : fallbackScore;

                return {
                    ...item.entry,
                    left: slot.left,
                    top: slot.top,
                    score,
                };
            });
    }

    private tokenize(value: string): string[] {
        return value
            .split(/[^0-9a-zA-Z가-힣]+/)
            .map((token) => token.trim())
            .filter((token) => token.length > 1);
    }

    private normalize(value: string): string {
        return value.toLowerCase().trim();
    }

    private resolveSubtopic(topicId: string, subtopicId = ''): TopicSubtopic | undefined {
        if (!subtopicId) {
            return undefined;
        }

        return (TOPIC_SUBTOPICS[topicId] || []).find((item) => item.id === subtopicId);
    }

    private resolveLegacyDraftId(topicId: string, subtopicId = ''): string {
        if (topicId !== 'wiki-operations' || !/^draft-[a-z0-9-]+$/i.test(subtopicId)) {
            return '';
        }

        return subtopicId;
    }

    private getInputValue(event: Event): string {
        const input = event.target as HTMLInputElement;
        return input.value || '';
    }

    private compactQuery(value: string): string {
        return value.replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    private hydrateSharedState() {
        const state = this.getSharedState();
        this.searchQuery = state.searchQuery || '';
        this.hasSearched = false;
        this.graphSeed = state.graphSeed || '';
        this.selectedFileName = state.selectedFileName || '';
        this.graphSourceSummary = state.graphSourceSummary || '';
        this.uploadedText = state.uploadedText || '';
    }

    private restoreDirectoryScroll() {
        const state = this.getSharedState();
        const scrollTop = Number(state.pendingDirectoryScrollTop);

        if (!Number.isFinite(scrollTop)) {
            return;
        }

        delete state.pendingDirectoryScrollTop;
        [0, 160].forEach((delay) => {
            window.setTimeout(() => window.scrollTo(0, scrollTop), delay);
        });
    }

    private persistSharedState() {
        const state = this.getSharedState();
        state.searchQuery = this.searchQuery;
        state.hasSearched = false;
        state.graphSeed = this.graphSeed;
        state.selectedFileName = this.selectedFileName;
        state.graphSourceSummary = this.graphSourceSummary;
        state.uploadedText = this.uploadedText;
    }

    private getSharedState() {
        const root = window as any;
        root.__mainWikiState = root.__mainWikiState || {};
        return root.__mainWikiState;
    }
}

export default PageMainTopicComponent;